enum GenderName {
  Boys = 'Boys',
  Girls = 'Girls',
  CoEd = 'Co-ed'
}

export default GenderName;
